import * as React from "react";
function SvgInstagramPersonal(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M18.5 17.2a6.71 6.71 0 10-5.2 0 10 10 0 00-7.5 9.7v.8h5.9V26h-4a8.35 8.35 0 0116.6 0h-4.2v1.7H26v-.8a10 10 0 00-7.5-9.7zM11 11c0-2.8 2.2-5 5-5s5 2.2 5 5-2.2 5-5 5-5-2.2-5-5z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgInstagramPersonal);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
